export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED";
export const RECEIVE_NOTIFICATION = "RECEIVE_NOTIFICATION";
export const MARK_ALL_NOTIFICATIONS_AS_READ = "MARK_ALL_NOTIFICATIONS_AS_READ";
export const MARK_NOTIFICATION_AS_READ = "MARK_NOTIFICATION_AS_READ";
export const FETCH_MORE_NOTIFICATIONS_REQUEST = "FETCH_MORE_NOTIFICATIONS_REQUEST";
export const FETCH_MORE_NOTIFICATIONS_SUCCESS = "FETCH_MORE_NOTIFICATIONS_SUCCESS";
export const FETCH_MORE_NOTIFICATIONS_FAILED = "FETCH_MORE_NOTIFICATIONS_FAILED";
